import axios from "axios";
import {db_url} from "../url";

export default function Db_cube(token) {

    const getCheckCub = (controller) => {
        return axios.get(db_url + `/admin/cube/check`, {
            signal: controller.signal,
            headers: {
                Authorization: token
            }
        })
    }

    const startCub = (controller) => {
        return axios.put(db_url + `/admin/cube/start`, null, {
            signal: controller.signal,
            headers: {
                Authorization: token
            }
        })
    }

    const stopCub = (controller) => {
        return axios.put(db_url + `/admin/cube/stop`, null,{
            signal: controller.signal,
            headers: {
                Authorization: token
            }
        })
    }

    const clearSaleCub = (data) => {
        return axios.post(db_url + `/admin/cube/sales/clear`, data,{
            headers: {
                Authorization: token
            }
        })
    }


    return {
        getCheckCub,
        startCub,
        stopCub,
        clearSaleCub,
    }
}